import React, { useMemo } from "react";
import Cookies from "js-cookie";
import { Elements } from "@stripe/react-stripe-js";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import MyFilesPage from "../pages/MyFilesPage";
import SettingsPage from "../pages/SettingsPage";
import BillingInfo from "../pages/BillingInfo";
import HeaderDashboard from "../components/dashboard/header/HeaderDashboard";
import Search from "../components/dashboard/header/Search";
import MyMessagesPage from "../components/dashboard/components/MyMessagesPage";
import CheckoutPage from "../pages/CheckoutPage";
import SuccessPage from "../pages/SuccessPage";
import useSubscription from "../hooks/useSubscription";
import BillingPlanPage from "../pages/BillingPlanPage";
import PreviewMessageMobile from "../pages/PreviewMessageMobile";

const ProtectedLayout = () => {
  const location = useLocation();
  const { REACT_APP_STRIPE_KEY } = process.env;
  const stripePromise = useMemo(
    () => loadStripe(REACT_APP_STRIPE_KEY),
    [REACT_APP_STRIPE_KEY],
  );
  const plans = useSubscription();

  const accessToken = Cookies.get("AccessToken");
  const hideSearchPaths = ["/dashboard/billing", "/dashboard/settings"];
  const shouldHideSearch = hideSearchPaths.includes(location.pathname);

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  return (
    <>
      <div className="h-screen overflow-hidden">
        <div className="flex mobile:flex-col h-full">
          <HeaderDashboard />
          <div className="right-side-desktop mobile:h-full desktop:h-full bg-gray2 w-full flex flex-col min-h-0">
            <div className="search bg-white mobile:hidden flex-shrink-0">
              <Search hideSearchInput={shouldHideSearch} />
            </div>

            <div className="content-page flex-1 desktop:px-9 desktop:pt-9 desktop:pb-9 overflow-y-auto min-h-0">
              <Routes>
                <Route index element={<MyMessagesPage />} />
                <Route
                  path="preview/:messageId"
                  element={<PreviewMessageMobile />}
                />
                <Route path="my-files/*" element={<MyFilesPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route
                  path="billing"
                  element={
                    <Elements stripe={stripePromise}>
                      <BillingInfo />
                    </Elements>
                  }
                />
                <Route
                  path="billing/plans"
                  element={<BillingPlanPage plans={plans} />}
                />
                <Route
                  path="billing/plans/checkout/:planId"
                  element={
                    <Elements stripe={stripePromise}>
                      <CheckoutPage />
                    </Elements>
                  }
                />
                <Route path="success" element={<SuccessPage />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProtectedLayout;
